import React, {Component} from 'react';
import * as R from 'ramda';

// Components
import ContentLeaderboardImagesContainer from './content_leaderboard_images_container';

class ContentLeaderboard extends Component {
    constructor() {
        super();
        this.state = {
            selectedPost: {},
            showContentModal: false
        };
    }

    setSelectedPost = contentMetadataId => {
        const {leaderboardContent} = this.props;

        const selectedIndex = R.findIndex(R.propEq('content_metadata_id', contentMetadataId))(
            leaderboardContent
        );
        const selected = leaderboardContent[selectedIndex];

        this.setState(
            {
                selectedPost: selected
            },
            this.openContentModal
        );
    };

    openContentModal = () => {
        this.setState({
            showContentModal: true
        });
    };

    closeContentModal = () => {
        this.setState({
            showContentModal: false
        });
    };

    displayContentGalleryLink = () => {
        const {renderForPdf, campaignId, analyticsUrl} = this.props;
        const contentGalleryUrl = analyticsUrl.replace('__id__', campaignId);

        if (!renderForPdf) {
            return (
                <div className="content-leaderboard-gallery-link">
                    <a id="content-leaderboard-link" href={contentGalleryUrl}>
                        SEE FULL CONTENT GALLERY
                        <span className="link-carrot"> &gt;</span>
                    </a>
                </div>
            );
        }
    };

    render() {
        const {campaignName, renderForPdf, bgColor} = this.props;
        const contentGalleryLink = this.displayContentGalleryLink();

        return (
            <div className="content-leaderboard wrap-up-section">
                <div className="content-leaderboard-header-container">
                    <div className="content-leaderboard-header-title">Content Leaderboard</div>
                    <div className="content-leaderboard-header-subtitle">
                        {`Here is some of your most popular content from the ${campaignName} Campaign.`}
                    </div>
                </div>
                <ContentLeaderboardImagesContainer
                    downloadUrl={this.props.downloadUrl}
                    isAdmin={this.props.isAdmin}
                    leaderboardContent={this.props.leaderboardContent}
                    selectedPost={this.state.selectedPost}
                    closeContentModal={this.closeContentModal}
                    setSelectedPost={this.setSelectedPost}
                    showKoer={this.props.showKoer}
                    showContentModal={this.state.showContentModal}
                    showVideoViews={this.props.showVideoViews}
                    renderForPdf={renderForPdf}
                />
                {contentGalleryLink}

                {/*STYLES*/}

                <style>{`
                    .content-leaderboard {
                        background-color: ${bgColor};
                    }

                    .content-leaderboard-header-title {
                        font-size: 36px;
                        font-weight: 200;
                        padding-top: 40px;
                    }

                    .content-leaderboard-header-subtitle {
                        width: 85%;
                        font-size: 20px;
                        font-weight: 200;
                        text-align: center;
                        padding: 10px 0px 40px 0px;
                    }

                    .content-leaderboard-gallery-link {
                        padding: 0px 0px 20px;
                    }

                    #content-leaderboard-link {
                        font-size: 18px;
                        font-weight: bold;
                        color: #000;
                        text-decoration: none;
                    }

                    .link-carrot {
                        font-size: 20px;
                        color: #00A1E1;
                        font-weight: bold;
                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .content-leaderboard-header-container {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                        }

                        .content-leaderboard-gallery-link {
                            display: flex;
                            justify-content: center;
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .content-leaderboard {
                            padding-top: 40px;
                        }

                        .content-leaderboard-header-container {
                            text-align: center;
                        }

                        .content-leaderboard-header-subtitle {
                            margin: auto;
                        }

                        .content-leaderboard-gallery-link {
                            text-align: center;
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

ContentLeaderboard.propTypes = {};

export default ContentLeaderboard;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/content_leaderboard/index.js